module.exports = __webpack_public_path__ + "static/media/Lucky-Spins-Two-Lines-Pattern-Yellow-800x480.d82a8590.png";